import { Component, OnInit } from '@angular/core';

import { MatomoService } from '@services/matomo.service';

import { environment } from '@envs/environment';
import { fadeAnimation } from './app.animations';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [
        fadeAnimation
    ],
    standalone: false
})
export class AppComponent implements OnInit {

    constructor(
        private matomoService: MatomoService,
    ) { }

    ngOnInit(): void {
        if (environment.launchpad?.enabled) {
            const script = document.createElement('script');
            script.src = environment.launchpad.url;
            script.type = 'module';
            document.body.appendChild(script);
        }

        this.matomoService.initializeMatomo();
    }

}
